module.exports = __webpack_public_path__ + "media/components/SelectToken/copy-23327029bd6e71f73ef936007295ec94.svg";